import _ from "lodash";
import { Dispatch, SetStateAction } from "react";
import { Fields, Errors } from "./types";

export const validateYup = (
  fields: Fields,
  schema: any ,
  setErrors: (errors: Errors) => void
): boolean => {
  let errors: Errors = {};

  try {
    schema.validateSync(fields, { abortEarly: false });
  } catch (err: any) {
    errors = err.inner.reduce(
      (acc: any, e: any) => ({ ...acc, [e.path]: e.message }),
      {}
    );
  }

  setErrors(errors);

  return _.isEmpty(errors);
};

/**
 * Briše poruke s polja koja su se upravo promijenila.
 *
 * Bez ovoga greška stoji sve do sljedeće validacije — pa polje ostaje crveno i nakon što
 * se popuni (npr. kontakt odabran iz modala za unos novog). `prefix` je za sheme koje
 * polja ugnijezde, gdje Yup putanje glase "location.contactId".
 */
export const clearChangedErrors = (
  prevValues: Fields,
  nextValues: Fields,
  setErrors: Dispatch<SetStateAction<Errors>>,
  prefix: string = ""
): void => {
  const changed = Object.keys(nextValues).filter(
    (key) => nextValues[key] !== prevValues[key]
  );

  if (!changed.length) return;

  setErrors((errors) => {
    const keys = changed.map((key) => `${prefix}${key}`);
    if (!keys.some((key) => errors[key])) return errors;

    return _.omit(errors, keys);
  });
};






